<div class="footer">
    <div class="d-flex justify-content-center">
        <div class="line"></div>
        <div class="dotted"></div>
    </div>
    <div class="row m-0 footer-container">
        <div class="col-md-3 col-sm-2 align-self-center text-center">
            <div class="image">
                <a [routerLink]="['']">
                    <img id="main-logo" ngSrc="../../../../assets/images/trialresults_logo.png" height="53" width="203"
                        alt="TrialResults logo for accessing clinical trial results and plain language summaries" ngOptimizedImage />
                </a>
            </div>
        </div>

        <div class="col-md-6 col-sm-7 about-section d-flex">
            <div class="vl"></div>
            <div class="middle-content">
                <div class="pb-2 footer-subheader">About</div>
                <div class="text-primary text-justify">
                    TrialResults.com
                    is intended for those who are interested in the
                    results of
                    completed clinical trials in an easily understood format. This information is made available by
                    <a class="about pb-1 text-decoration-none text-info" href="https://www.trialassure.com"
                        target="_blank">
                        TrialAssure</a>, a global company committed to clinical trial and human health data transparency
                    for the
                    entire pharmaceutical industry.
                </div>

                <div class="pt-4 pb-2 footer-subheader">Disclaimer</div>
                <div class="text-primary text-justify">Many of these summaries are based on the data provided by the
                    study sponsor to
                    ClinicalTrials.gov and have been generated using Artificial Intelligence enabled by TrialAssure
                    LINK® software. Do not use these summaries to make medical decisions. Consult a healthcare
                    professional if you have questions related to any treatment programs. Please see ClinicalTrials.gov
                    for the full disclaimer related to this information:
                    <a class="about pb-1 text-decoration-none text-info"
                        href="https://clinicaltrials.gov/about-site/disclaimer" target="_blank">
                        https://clinicaltrials.gov/about-site/disclaimer
                    </a>
                </div>
            </div>

        </div>

        <div class="col-md-3 col-sm-3 quick-links">
            <div class="footer-subheader pb-3">Quick Links</div>
            <a class="d-block about pb-1 text-decoration-none text-info" href="https://clinicaltrials.gov/"
                target="_blank">
                ClinicalTrials.gov
            </a>
            <a class="d-block about pb-1 text-decoration-none text-info" href="https://www.clinicaltrialsregister.eu/"
                target="_blank">
                EU Clinical Trials Register
            </a>
            <a class="contact" href="https://www.trialassure.com/about/contact/" target="_blank">
                <i-feather name="phone" class="icons"></i-feather> Contact Us
            </a>
        </div>
    </div>
    <div class="row justify-content-center socials m-0">
        <div class="col-lg-1">
            <a class="text-muted" href="https://www.linkedin.com/company/16175554/" target="_blank">
                <i-feather name="linkedin" class="icons me-2"></i-feather>
            </a>
            <!-- <a class="text-muted" href="https://twitter.com/trialassure" target="_blank">
                <i-feather name="twitter" class="icons"></i-feather>
            </a> -->
        </div>
        <div class="col-lg-2">
            <a class="text-decoration-none text-muted" href="mailto:info@trialassure.com">
                info@trialassure.com
            </a>
        </div>
        <div class='col-lg-4 col-sm-12'>
            <span>6880 Commerce Blvd., Canton, MI
                48187,
                USA </span>
        </div>
    </div>
</div>